import React from 'react';
import { Section } from './ui/Section';
import { Container } from './ui/Container';
import { SearchIcon, DownloadIcon, UsersIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    icon: SearchIcon,
    title: '1. Explora el Catálogo',
    description: 'Navega por nuestros MegaPacks y encuentra los recursos que mejor se adapten a tu área y nivel educativo.'
  }, {
    icon: DownloadIcon,
    title: '2. Recibe tus Recursos',
    description: 'Una vez procesada la adquisición, recibes acceso inmediato a todos los archivos en formato digital por correo electrónico.'
  }, {
    icon: UsersIcon,
    title: '3. Aplica en el Aula',
    description: 'Utiliza los materiales directamente o edítalos según tu contexto. Están diseñados para facilitar tu labor docente.'
  }];
  return <Section id="como-funciona" data-id="element-92">
      <Container data-id="element-93">
        <div className="text-center mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-95">
            ¿Cómo Funciona Nuestro Servicio?
          </h2>
          <p className="text-lg text-brand-navy-700 max-w-2xl mx-auto" data-id="element-96">
            Un proceso simple y directo para que accedas a recursos educativos
            de calidad sin complicaciones.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-97">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-brand-navy-100 -z-10 border-t-2 border-dashed border-brand-navy-200" data-id="element-98"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col items-center text-center bg-white p-8 rounded-2xl shadow-sm border border-brand-cream-100 relative" data-id="element-99">
              <div className="w-24 h-24 bg-brand-cream-50 rounded-full flex items-center justify-center mb-6 border-4 border-white shadow-sm z-10" data-id="element-100">
                <step.icon className="w-10 h-10 text-brand-amber-500" data-id="element-101" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-brand-navy-900" data-id="element-102">
                {step.title}
              </h3>
              <p className="text-brand-navy-700 leading-relaxed" data-id="element-103">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </Container>
    </Section>;
}